<template>
  <footer>
    <div class="wrapper">
      <div class="left">
        <p>&copy;{{ new Date().getFullYear() }} Intercollegiate Mens Lacrosse Coaches Association (IMLCA). All Rights <br>Reserved.</p>
        <p> Powered by <a href="https://mangoconcept.com/" target="_blank">Mango Concept</a></p>
      </div>
      <div class="right">
        <a>Terms & Conditions</a> |
        <a>Privacy Policy</a>
      </div>
    </div>
  </footer>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
footer {
  background-color: #22272B;
  padding: 20px;
  position: fixed;
  max-width: 74.2222%;
  width: 100%;
  right: 0;
  bottom: 0;
}

.wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

p {
  font-size: 16px;
  line-height: 18px;
  padding-bottom: 10px;
  color: #fff;
  a {
    color: #3B4AFF;
    text-decoration: none;
  }
}

.right {
  color: #fff;
  font-size: 16px;
  a {
    color: #3B4AFF;
    text-decoration: none;
    margin: 0 8px;
  }
}
</style>